module.exports = __webpack_public_path__ + "static/media/marker4.4d76c05c.png";